/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

jQuery(window).on("load", function (e) {
  
  function updatecheck(check){
  	var magnification = jQuery(".single-option-selector--0").val();
    var color = jQuery(".single-option-selector--1").val();
    
    jQuery(".magnification li").removeClass("active");
    jQuery(".magnification li").each(function(){
    	if(jQuery(this).attr("valdata")==magnification)
          jQuery(this).addClass("active");
    });
    
    jQuery(".color li").removeClass("active");
    jQuery(".color li").each(function(){
      if(jQuery(this).attr("valdata")==color){
          jQuery(this).addClass("active");
          jQuery("li.selectedtext").html(color);
      }
    });
    if(check==1){      
        jQuery(".color li").removeClass("nodata");
      	jQuery(".color li").each(function(){
          	var jquerycolor = jQuery(this);
          	jQuery("#productSelect-1 option").each(function(){
              //console.log(jQuery(this).text()+"========="+jQuery(".magnification .active").attr("valdata")+" / "+jquerycolor.attr("valdata")+" - Sold Out");
              if(jQuery(this).text()==jQuery(".magnification .active").attr("valdata")+" / "+jquerycolor.attr("valdata")+" - Sold out"){
              	//we disable the color
                jquerycolor.addClass("nodata");
              }
            });
        });
    }
    if(check==2){      
        jQuery(".magnification li").removeClass("nodata");
      	jQuery(".magnification li").each(function(){
          	var jquerymagnification = jQuery(this);
          	jQuery("#productSelect-1 option").each(function(){
                
              //console.log(jQuery(this).text()+"========="+jquerymagnification.attr("valdata")+" / "+jQuery(".color .active").attr("valdata")+" - Sold Out");
              if(jQuery(this).text()==jquerymagnification.attr("valdata")+" / "+jQuery(".color .active").attr("valdata")+" - Sold out"){
              	//we disable the color
                jquerymagnification.addClass("nodata");
              }
            });
        });
    }
  }
  
  setTimeout(function(){
    if(jQuery("ul.color li").length <= 2){
    	jQuery(".opdata.colorlist").hide();
      	//alert(jQuery("ul.color li").length);
    }
    var items = jQuery(".color li").get();
    items.sort(function(a,b){
      var keyA = $(a).text();
      var keyB = $(b).text();

      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
      return 0;
    });
    var ul = jQuery(".color");
    jQuery.each(items, function(i, li){
      ul.append(li);
    });    
    
    jQuery(".magnification li").click(function(){
      if(!jQuery(this).hasClass("nodata")){
      	jQuery(".single-option-selector--0").val(jQuery(this).attr("valdata"));
        if (jQuery(".single-option-selector--0")[0] != null) {
          jQuery(".single-option-selector--0")[0].dispatchEvent(new Event('change', { 'bubbles': true }));
        }
      	updatecheck(1);
      }
    });
    jQuery(".color li").click(function(){
      if(!jQuery(this).hasClass("nodata") && !jQuery(this).hasClass("selectedtext")){
      	jQuery(".single-option-selector--1").val(jQuery(this).attr("valdata"));
        if (jQuery(".single-option-selector--1")[0] != null) {
          jQuery(".single-option-selector--1")[0].dispatchEvent(new Event('change', { 'bubbles': true }));
        }
      	updatecheck(2);
      }
    });
    
    updatecheck(2);
    
  }, 100);
  /*
  //jQuery(".accordion li div.listitem").hide();
  //jQuery(".accordion li h3").click(function(){
  //	jQuery(this).parent().children(".listitem").toggle();
  //});
  var url = window.location.href.toString().split('/');
  var urlparameter = "";
  if(url.length > 0){
    urlparameter = url[url.length-1].toString().split('+');
    jQuery(".accordion li div.listitem input").each(function(){
      for (i = 0; i < urlparameter.length; i++) { 
        if(urlparameter[i]==jQuery(this).val().toString()){
        	jQuery(this).attr("checked","checked");
        }
      }      
    });
    
  }
  //console.log(urlparameter);
  jQuery(".accordion li div.listitem input").click(function(){
    //if(jQuery(this).is(":checked")){
    //  jQuery(this).parent().parent().find("input").removeAttr("checked");
    //  jQuery(this).attr("checked", "checked");
    //}
    var listurl = "";
    jQuery(".accordion li div.listitem input").each(function(){
      if(jQuery(this).is(':checked')){
        listurl = listurl + jQuery(this).val().toString() + "+";
      }  
    });
    listurl = listurl.substring(0, listurl.length-1);
    if(listurl)
  		location.href=jQuery(".urlval").val()+"/"+listurl;
    else
  		location.href=jQuery(".urlval").val();
  });
  */
  jQuery("div.listitem input").click(function(){
    if(jQuery(this).is(":checked")){
    	jQuery("."+jQuery(this).attr("class")).attr("checked","checked");
    }
    else{
    	jQuery("."+jQuery(this).attr("class")).attr("checked","");
    }
    //jQuery(".jq-dropdown").hide();
    //jQuery(".jq-dropdown-open").removeClass("jq-dropdown-open");
    jQuery(".collection-products .o-layout__item").hide();
    jQuery(".filterrr").html("");
    var checkdata = 0;
    var checkedlist = [];
    var counterarray = 0;
    jQuery(".filterproducts div.listitem input").each(function(){
    	if(jQuery(this).is(":checked")){
          var rel = jQuery(this).parent().parent().attr("rel");
          var val = jQuery(this).val();
          var text = jQuery(this).parent().children("span").text();
          //jQuery("."+rel+"-"+val).show();
          checkedlist[counterarray] = rel+"-"+val;
          jQuery(".filterrr").append("<span val='"+val+"' rel='"+rel+"'>"+text+" x</span>");
          checkdata = 1;
          counterarray = counterarray + 1;
    	}
   	});
    if(checkdata==1){
      jQuery(".filterrtxt").html("Filters Selected: ");
    	jQuery(".filterrr").append("<span class='clearall'>Clear All</span>");
    }
    //alert(checkedlist);
    //($('html').is('.m320, .m768')) { ... }
    var carray = 0;
    jQuery(".collection-products .o-layout__item").each(function(){
      	carray = 0;
        for(var ctemp=0;ctemp<checkedlist.length;ctemp++){
          if(jQuery(this).hasClass(checkedlist[ctemp])) {
            carray = carray + 1;
            jQuery(this).show();
          }
        }
        //if(carray==checkedlist.length){
        //  jQuery(this).show();
        //}
    });
    
    jQuery(".filterrr span").unbind("click").bind("click",function(){
      if(jQuery(this).hasClass("clearall")){
    	jQuery(".filterrr span").remove();
    	jQuery(".filterrtxt").html("");
        jQuery(".filterproducts input").removeAttr("checked");
    	window.history.pushState('page', 'page', '?');
        location.reload();
      }
      else{
        jQuery(".filterproducts ."+jQuery(this).attr("rel")+" input[value='"+jQuery(this).attr("val")+"']").click();
        jQuery(this).remove();
      }
    });
    if(checkdata==0){
      jQuery(".collection-products .o-layout__item").show();
    }
    var checkdata = 0;
    jQuery(".filterproducts div.listitem input").each(function(){
    	if(jQuery(this).is(":checked")){
          checkdata = 1;
    	}
   	});
    if(checkdata==0){
      jQuery(".filterrtxt").html("");
    }
    //if(checkdata){
    //	jQuery(".o-layout__item").show();
    //}
    //  jQuery(this).parent().parent().find("input").removeAttr("checked");
    //  jQuery(this).attr("checked", "checked");
    //}
    var filterselection = "";
    jQuery(".filterproducts div.listitem input").each(function(){
      if(jQuery(this).is(':checked')){
        if(filterselection=="")
          filterselection = jQuery(this).attr("name") + "-" + jQuery(this).val();
        else
          filterselection = filterselection + "," + jQuery(this).attr("name") + "-" + jQuery(this).val();
      }
    });
    if(filterselection!="")
    	window.history.pushState('page', 'page', '?filter='+filterselection);
    else
    	window.history.pushState('page', 'page', '?');
  });
  
  jQuery("a.filterresults").click(function(e){
  	jQuery(".toggmobile").toggle();
    if(jQuery(".toggmobile").is(":visible")){
      jQuery("a.filterresults .plus-minus-toggle").removeClass("collapsed");
    }
    else{
      jQuery("a.filterresults .plus-minus-toggle").addClass("collapsed");
    }
    e.preventDefault();
  });
  
  var filter = getUrlParameter("filter");
  if(filter!=""){
    var filtersplit = filter.split(",");
    var len = filtersplit.length;
    for (i = 0; i < len; i++) {
      var tempstring = filtersplit[i].split("-");
      jQuery("input[name='"+tempstring[0]+"'][value='"+tempstring[1]+"']").click();
    }    
    jQuery("html, body").animate({ scrollTop: jQuery(".filterproducts").offset().top-100 });
    
  }
  
});
